import { EXPLAINED_ROUTE_SHAPE } from '../../../utils/get-explained-term-canonical-path';
import ExplainedPage from '../../../../src/client/pages/explained-term/page';
import explainedTermStaticProps from '../../../utils/get-explained-term-static-props';
import getStaticPathsForExplainedTerms from '../../../utils/get-static-paths-for-explained-terms';

export const getStaticPaths = () => getStaticPathsForExplainedTerms(EXPLAINED_ROUTE_SHAPE.HEALTH);

export const getStaticProps = explainedTermStaticProps(EXPLAINED_ROUTE_SHAPE.HEALTH);

export default ExplainedPage;
